import * as form from '../form';

export const substanceDrugClearance = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Description: form.textarea(xitem.Description),
        InvolvementDates: form.daterange(xitem.InvolvementDates),
        EstimatedUse: form.text(xitem.EstimatedUse),
        Comments: form.textarea(xitem.Comments),
        DrugType: form.radio(xitem.DrugType), // PVQ Only
        DrugTypeOther: form.textarea(xitem.DrugTypeOther), // PVQ Only
        HowManyTimes: form.text(xitem.HowManyTimes), // PVQ Only
        Reason: form.textarea(xitem.Reason), // PVQ Only
      },
    };
  });
  return {
    UsedDrugs: form.branch(data.UsedDrugs),
    List: form.collection(items, (data.List || {}).branch),
    Comments: form.textarea(data.Comments),
    SummaryComments: form.textarea(data.SummaryComments),
  };
};
